
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{category?  "Edit Category": "New Category"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="form-group">
              <label class="form-label">Category Name</label>
              <input type="text" class="form-control" formControlName="name">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['name'].errors?.['required'] && (f2['name'].dirty || f2['name'].touched)">
                  Please fill name.
              </div>
          </div>
          <div class="form-group" [attr.readonly]="isReadOnly()">
            <label class="form-label">Type</label>
            <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="type" [(ngModel)]="type" (change)="typeChange()" class="selectpicker type font-oswald w-100">
              <option value="general">General</option>
              <option value="series">Series</option>
            </select>
            <div class="invalid-feedback d-block"
                *ngIf="f2['type']?.errors?.['required'] && f2['type'].touched && f2['type']?.invalid">
                Please select type.
            </div>
          </div>
          <div class="" *ngIf="type=='general'">
            <div class="form-group">
              <label class="form-label">Skill Types</label>
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="formskills" multiple class="selectpicker skill font-oswald w-100">
                <option *ngFor="let selectskill of allskills" [value]="selectskill?.id">{{selectskill?.name | titlecase}}</option>
              </select>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['formskills']?.errors?.['required'] && f2['formskills'].touched && f2['formskills']?.invalid">
                  Please select skill.
              </div>
            </div>
            <label class="form-label">Options</label>
            <hr/>
            <ng-container formArrayName="formoptions">
              <ng-container *ngFor="let formoptionsForm of formoptions?.controls; let i = index">
                <div class="row mb-2" [formGroupName]="i">
                  <div class="col-md-5 form-group">
                    <label class="form-label">Option</label>
                    <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="option" title="Select option" class="selectpicker option font-oswald w-100">
                      <option value="">Select Option</option>
                      <option *ngFor="let selectrule of alloptions" [value]="selectrule?.id">{{selectrule?.name | titlecase}}</option>
                    </select>
                    <div class="invalid-feedback d-block"
                        *ngIf="f2['formoptions']['controls'][i]['controls'].option?.errors?.['required'] && f2['formoptions']['controls'][i]['controls'].option?.touched && f2['formoptions']['controls'][i]['controls'].option?.invalid">
                        Please select option.
                    </div>
                  </div>
                  <div class="col-md-5 form-group">
                    <label class="form-label">Choices</label>
                    <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="choice" multiple title="Select option" class="selectpicker choice font-oswald w-100">
                      <option value="">Select Choice</option>
                      <option *ngFor="let selectrule of allchoices" [value]="selectrule?.id">{{selectrule?.name | titlecase}}</option>
                    </select>
                    <div class="invalid-feedback d-block"
                        *ngIf="f2['formoptions']['controls'][i]['controls'].choice?.errors?.['required'] && f2['formoptions']['controls'][i]['controls'].choice?.touched && f2['formoptions']['controls'][i]['controls'].choice?.invalid">
                        Please select choice.
                    </div>
                  </div>
                  
                  <div class="col-md-2">
                    <label class="form-label">Remove</label>
                    <div>
                      <button class="btn btn-sm btn-danger" (click)="deleteformoptions(i)"><i class="fa fa-trash"></i></button>
                    </div>
                  </div>
                </div>
                <hr/>
              </ng-container>
            </ng-container>
          </div>

          <button type="button" class="btn btn-secondary btn-sm me-3" (click)="addOption()" *ngIf="type=='general'">Add Option</button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>